/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Mfa_Page_TitleInputs */

const de_auth_mfa_page_title = /** @type {(inputs: Auth_Mfa_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identität bestätigen`)
};

/** @type {(inputs: Auth_Mfa_Page_TitleInputs) => LocalizedString} */
const en_auth_mfa_page_title = de_auth_mfa_page_title;

/**

* @param {Auth_Mfa_Page_TitleInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_mfa_page_title = /** @type {((inputs?: Auth_Mfa_Page_TitleInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Mfa_Page_TitleInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_auth_mfa_page_title(inputs)
	return en_auth_mfa_page_title(inputs)
});